module.exports = __webpack_public_path__ + "85573521967c8d7977f56915e917b4b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/bwappexample.png
// module id = 1284
// module chunks = 10